<template>
  <section class="wrapper relative">
    <icon
      @click.native="prev"
      scale="2.9"
      class="is-hoverable absolute"
      :class="{ gray: false }"
      name="chevron-left"
    />
    <icon
      @click.native="next"
      scale="2.9"
      class="is-hoverable absolute"
      :class="{ gray: false }"
      name="chevron-right"
    ></icon>
    <carousel
      v-if="slides.length"
      :adjustableHeight="true"
      :per-page="1"
      ref="carousel"
      :navigationSize="1000"
      navigationNextLabel=">"
      navigationPrevLabel="<"
      :navigation-enabled="true"
      :navigationColor="'white'"
      :paginationEnabled="false"
      :paginationColor="'black'"
    >
      <slide style="position: relative" v-for="slide in slides">
        <hero
          :top="true"
          :backgroundImage="`https://${baseURL()}${slide.value.path}`"
        ></hero>
      </slide>
    </carousel>
  </section>
</template>

<script>
import { bus } from "@/main";
export default {
  created() {
    // this.isLoading = true;
    bus.$on("sliderImages", (data) => {
      this.slides = data;
    });
  },
  data() {
    return {
      slides: [],
      isLoading: false,
    };
  },
  methods: {
    next() {
      const carousel = this.$refs["carousel"];
      const currentPage = carousel.currentPage;
      const pageCount = carousel.pageCount;
      currentPage < pageCount - 1
        ? carousel.goToPage(currentPage + 1)
        : carousel.goToPage(0);
    },
    prev() {
      const carousel = this.$refs["carousel"];
      const currentPage = carousel.currentPage;
      const pageCount = carousel.pageCount;
      currentPage != 0
        ? carousel.goToPage(currentPage - 1)
        : carousel.goToPage(pageCount - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  min-height: 85vh;
}
.wrapper /deep/ .VueCarousel-pagination {
  position: absolute;
  bottom: 0px;
}
.wrapper /deep/ .VueCarousel-navigation-next,
.VueCarousel-navigation-prev {
  transform: unset !important;
  // width: 10rem !important;
  font-size: 0px;
}
.wrapper {
  svg {
    color: rgb(240, 74, 36);
    &:first-child {
      left: 30px;
      top: 50%;
      z-index: 9;
    }
    &:nth-child(2) {
      top: 50%;
      right: 30px;
      z-index: 9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// landing.vue?9662f350